import { ActionTable } from "../../ActionTable/ActionTable";
import LicenseFilter from "../LicenseFilter";
import dateFnsFormat from 'date-fns/format';
import { useCallback, useEffect, useState } from "react";
import { listLicenses } from "../../../services/service";
import BtnAddLicense from "../BtnAddLicense";
import BtnAddLicenseType from "../BtnAddLicenseType";
import EditLicense from "../EditLicense";
import DeleteLicense from "../DeleteLicense";
import { parseDurationVerbose } from "../../../services/utils";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { blue } from '@material-ui/core/colors/';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import LinkLicenseModal from '../../../components/License/LinkLicense';
import { Box } from '@mui/material';

const defaultResponse = {
  count: 0, results: [], next: null, previous: null
}

const ColorButton = styled(Button)(({ theme }) => ({
  color: 'white',
  backgroundColor: blue[700],
  '&:hover': {
    backgroundColor: blue[900],
  },
}));


export default function Licenses(props) {
  const { tabIndex } = props;
  const [loading, setLoading] = useState(true);
  const [editModal, setEditModal] = useState(false);
  const [licensesData, setLicensesData] = useState(defaultResponse);
  const [licenseData, setLicenseData] = useState({});
  const [deleteModal, setDeleteModal] = useState(false);
  const [currentLicensePage, setCurrentLicensePage] = useState(0);
  const [currentLicensePageSize, setCurrentLicensePageSize] = useState(25);
  const [LinkModal, setLinkModal] = useState(false)
  const [choseLicenseData, setChoseLicense] = useState(false)
  const [licenseFilters, setLicenseFilters] = useState({
    expand: "license_type,company",
  })

  const licenseColumnsMap = {
    id: "ID",
    company: "Empresa",
    duration_verbose: "Duração",
    license_type: "Modelo da Licença",
    created_at: "Data de Criação",
    is_linked: "Licença Vinculada?",
    is_server_type: "Licença de Servidor?"
  }
  const handleLicenseEdit = (valueData) => {
    setEditModal(true)
    setLicenseData(valueData)
  }

  const handleLicenseDelete = (valueModel) => {
    setDeleteModal(true)
    setLicenseData(valueModel)
  }

  const parseLicenseData = (data) => {
    data.results.map((el) => {
      el["duration_verbose"] = parseDurationVerbose(el.duration)
      el["created_at"] = dateFnsFormat(new Date(el.created_at), 'dd/MM/yy HH:mm')
      el["company_id"] = el.company.id || el.company
      el["company"] = el.company.name || el.company
      if (el.license_type) {
        el["license_type_id"] = el.license_type.id
        el["license_type"] = el.license_type.name
      }
      el["is_linked"] = el.is_linked ? "Vinculada" : "Não Vinculada"
      return el
    })
    setLicensesData(data)
  }

  useEffect(() => {
    listLicensesFn()
  }, [currentLicensePage, currentLicensePageSize, tabIndex])


  const listLicensesFn = useCallback(() => {
    setLoading(true);
    listLicenses(currentLicensePage + 1, currentLicensePageSize, licenseFilters)
      .then( (response) => {
        parseLicenseData(response.data)
      })
      .catch((error) => {
        // TODO: Add an alert notifying the user about this error.
        console.log(error)
      })
      .finally(setLoading(false))
  }, [currentLicensePage, currentLicensePageSize, tabIndex])


  const onLicenseChanged = (licenseData) => {
    listLicensesFn()
  }

  const onPageChange = (newPage) => {
    setCurrentLicensePage(newPage)
  }

  const onPageSizeChange = (newPageSize) => {
    setCurrentLicensePage(0)
    setCurrentLicensePageSize(newPageSize)
  }

  const handleLicenseLink = (valueData) => {
    setLinkModal(true)
    setLicenseData(valueData)
  }

  const handleSeeMoreLicense = (valueData) => {
    setLicenseData(valueData)
    window.open(`/licenses/${valueData.id}`, '_blank')
  }

  return (
    <Row>
      <EditLicense
        openModal={editModal}
        setOpenModal={setEditModal}
        licenseData={licenseData}
        onLicenseChanged={onLicenseChanged}
        sx={{ marginTop: 1 }}
      />
      <DeleteLicense
        openModal={deleteModal}
        setOpenModal={setDeleteModal}
        licenseData={licenseData}
        onLicenseChanged={onLicenseChanged}
        tableIndex = {tabIndex}
      />
      <LinkLicenseModal
        pageSize={currentLicensePageSize}
        openModal={LinkModal}
        setOpenModal={setLinkModal}
        licenseData={licenseData}
        onLicenseChanged={onLicenseChanged}
        choseLicenseData={choseLicenseData}
        setChoseLicense={(value) => setChoseLicense(value)}
      />

      <Col lg={9}>
        <LicenseFilter
          pageSize={currentLicensePageSize}
          setLicensesData={parseLicenseData}
          loading={loading}
          setLoading={setLoading}
          setFilters={setLicenseFilters}
        />
        <ActionTable
          title="Licenças"
          enableCheck
          currentPage={currentLicensePage}
          pageSize={currentLicensePageSize}
          pageSizeOptions={licensesData.count < 10 ? [10]
            : licensesData.count < 25
              ? [10, 25]
              : [10, 25, 40]
          }
          count={licensesData.count}
          columns={Object.keys(licenseColumnsMap)}
          columnsMap={licenseColumnsMap}
          valuesMap={{"is_server_type": (value) => value ? "Sim" : "Não"}}
          rows={licensesData.results}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
          onEditSelected={(licenseData) => handleLicenseEdit(licenseData)}
          onDeleteSelected={(licenseData) => handleLicenseDelete(licenseData)}
          onLinkLicense={(licenseData) => handleLicenseLink(licenseData)}
          onSeeMoreLicense={(licenseData) => handleSeeMoreLicense(licenseData)}
          setLinkLicenseIcon={true}
          setSeeMoreLicenseIcon={true}
        />
      </Col>
      <Col lg={3}>
        <Row>
          <BtnAddLicense onLicenseCreated={onLicenseChanged} />
          <BtnAddLicenseType
            sx={{ marginTop: 1 }}
            onLicenseCreated={onLicenseChanged}
          />
          <Box sx={{ marginTop: 1 }}>
            <ColorButton
              sx={{ padding: 2, width: "100%" }}
              startIcon={<InsertLinkIcon />}
              onClick={() => [
                setLinkModal(true), setChoseLicense(true)]}>
              Vincular Hardware
            </ColorButton>
          </Box>
        </Row>
      </Col >
    </Row >
  )
}
